export function onlyNumberInputPreventer(event: React.KeyboardEvent<HTMLInputElement>) {
  if (event.which < 48 || event.which > 57) {
    event.preventDefault()
  }
}
